import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/dapi-api-field/autocomplete/dapi-autocomplete'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  return {
    html,
    validators: [
      function (state, { errorMessage }) {
        if (!state?.matched) {
          return language[errorMessage];
        }
        return false;
      },
    ],
    config: {
      behaviour: 'text-input',
    },
  };
}
